export default __webpack_public_path__ + "static/media/FitCoin.9b4c3c0c.svg";